// extracted by mini-css-extract-plugin
export var barContainer = "_2m-0";
export var extraThin = "_2m-3";
export var fillBar = "_2m-6";
export var fillContainer = "_2m-4";
export var overflow = "_2m-8";
export var overflowContainer = "_2m-5";
export var regular = "_2m-7";
export var thick = "_2m-1";
export var thin = "_2m-2";